import * as tsresult from "./result_";

export type Ok<T> = tsresult.Ok<T>;
export const Ok = <T>(value: T) => new tsresult.Ok(value);

export type Err<T> = tsresult.Err<T>;
export const Err = <T>(value: T) => new tsresult.Err(value);

// # Result Type
// Wraps the `ts-result` library version, setting the `Err` type to `any`.
export type Result<T, E = any> = tsresult.Result<T, E>;
export const Result = {
  ...tsresult.Result,
  wrap,
  wrapAsync,
  Ok,
  Err,
};

// And an async alias
export type AsyncResult<T, E = any> = Promise<Result<T, E>>;
export const AsyncResult = { ...Result, wrapSync: wrap, wrap: wrapAsync };

// Wrap function `f` so that it returns a `Result` instead of exceptions.
function wrap<A extends Args, R>(f: ThrowerSync<A, R>): WrappedSync<A, R> {
  return (...args: A) => {
    try {
      return Ok(f(...args));
    } catch (e) {
      return Err(e);
    }
  };
}

// Wrap (async) function `f` so that it returns a `Result` instead of exceptions.
function wrapAsync<A extends Args, R>(
  f: ThrowerAsync<A, R>
): WrappedAsync<A, R> {
  return async (...args: A) => {
    try {
      return Ok(await f(...args));
    } catch (e) {
      return Err(e);
    }
  };
}

// Setup & type aliases for `wrap()` and `wrapAsync()`
type Args = Array<any>;
type ThrowerSync<A extends Args, Ret> = (...args: A) => Ret;
type ThrowerAsync<A extends Args, Ret> = (...args: A) => Promise<Ret>;
type WrappedSync<A extends Args, Ret> = (...args: A) => Result<Ret>;
type WrappedAsync<A extends Args, Ret> = (...args: A) => AsyncResult<Ret>;

export interface Error {
  why: string;
  data?: unknown;
}
